// extracted by mini-css-extract-plugin
export default {"content":"JJ-z","lookName":"KJ-z","shopTheLookContainer":"LJ-z","productContainer":"MJ-z","imageContainer":"NJ-z","mainImage":"OJ-z"};